import type { StaticParamsBase } from '../types/common'
import type { InputChangeValue, InteractionMethod } from '../utils/gaTracker'
import { gaTracker } from '../utils/gaTracker'
import { useAppContext } from './useAppContext'

export const useInputGaTracking = (fieldConfig: { enableGaTracking: boolean; description?: string; id?: string }) => {
  const { paramsStatic } = useAppContext<StaticParamsBase>()
  const isEnabled = () => fieldConfig.enableGaTracking && fieldConfig.description && fieldConfig.id

  const doTracking = (track: () => void) => {
    if (isEnabled()) {
      track()
    }
  }

  const trackInputChange = (value: InputChangeValue | null, method: InteractionMethod = 'editbox') => {
    return doTracking(() =>
      gaTracker.withVariant(paramsStatic.variant).onInputChange({
        elementID: fieldConfig.id as string,
        elementName: fieldConfig.description as string,
        value,
        method
      })
    )
  }

  return { trackInputChange }
}
